import { SocialAccountType } from '@anytag/graphql';
import { InfluencerSelectedAccountInfo } from '../../../types';
import { InfluencerProfileMixedAudience } from './InfluencerProfileMixedAudience';
import { InfluencerProfileEstimatedAudience } from './InfluencerProfileEstimatedAudience';

export interface InfluencerProfileAudienceProps {
  influencerId: number;
  socialAccount: InfluencerSelectedAccountInfo;
}

export const InfluencerProfileAudience = ({ influencerId, socialAccount }: InfluencerProfileAudienceProps) => {
  const isTwitterOrThreads = [SocialAccountType.TWITTER, SocialAccountType.THREADS].includes(
    socialAccount.type as SocialAccountType
  );

  return isTwitterOrThreads ? (
    <InfluencerProfileEstimatedAudience socialAccount={socialAccount} />
  ) : (
    <InfluencerProfileMixedAudience influencerId={influencerId} socialAccount={socialAccount} />
  );
};
